import { ShiveRoutes } from '../../segments/route-segments';
import { NavigationWrapper } from '../../navigation-data';

export const Finances: NavigationWrapper = {
  title: 'Finanzen',
  route: ShiveRoutes.Finances,
};

export const FinancesInvoicesOverview: NavigationWrapper = {
  title: 'Ausgangsrechnungen',
  route: ShiveRoutes.FinancesInvoicesOverview,
};

export const FinancesInvoicesAdd: NavigationWrapper = {
  title: 'Neue Ausgangsrechnung',
  route: ShiveRoutes.FinancesInvoicesAdd,
};

export const FinancesExpenses: NavigationWrapper = {
  title: 'Betriebsausgaben',
  route: ShiveRoutes.FinancesExpenses,
};
